export default __webpack_public_path__ + "static/media/property-1.759be7b3.png";